import { useState } from 'react'
import { useRecordContext } from 'react-admin'
import { Switch, FormControlLabel } from '@mui/material'
import get from 'lodash/get'

import useUpdateDataProvider from '../hooks/useUpdateDataProvider'

import { PODCAST_STATUS_DISPLAY, PODCASTER_STATUS } from './constants'

const PodcasterStatusField = props => {
  const { disabled } = props
  const updateDataProvider = useUpdateDataProvider()
  const record = useRecordContext()
  const [status, setStatus] = useState(record.status)

  const handleChange = async () => {
    const data = {
      status:
        status === PODCASTER_STATUS.PUBLISHED
          ? PODCASTER_STATUS.UNPUBLISHED
          : PODCASTER_STATUS.PUBLISHED,
    }

    const response = await updateDataProvider(
      'podcasters',
      { id: record.id, data },
      {
        onSuccess: {
          notification: { body: 'Podcaster updated', level: 'info' },
          redirectTo: '/podcasters',
        },
        onFailure: {
          notification: {
            body: 'Error: Podcaster not updated',
            level: 'warning',
          },
        },
      },
    )

    if (get(response, 'data.status', null)) {
      setStatus(response.data.status)
    }
  }

  return [
    PODCASTER_STATUS.PUBLISHED,
    PODCASTER_STATUS.UNPUBLISHED,
    PODCASTER_STATUS.UNDER_REVIEW,
  ].includes(record.status) ? (
    <FormControlLabel
      control={
        <Switch
          checked={status === PODCASTER_STATUS.PUBLISHED}
          onChange={handleChange}
          disabled={disabled}
        />
      }
      label={PODCAST_STATUS_DISPLAY[status]}
    />
  ) : (
    PODCAST_STATUS_DISPLAY[status]
  )
}

export default PodcasterStatusField
